import { render, staticRenderFns } from "./coreprotect.vue?vue&type=template&id=2194fae8&scoped=true&"
import script from "./coreprotect.vue?vue&type=script&lang=js&"
export * from "./coreprotect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2194fae8",
  null
  
)

export default component.exports